import * as React from 'react'
import { Menu, Dropdown } from 'antd'
import { InputField } from './input-field'
import { useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'
import { css } from '@emotion/core'
import {
  createSelfCheckinBaseStyle,
  createSelfCheckinResponsiveStyle,
  FrontTabletResponsiveToken,
} from '@/utils/front-tablet-responsive-style'

type Props = {
  value: string | undefined
  onClick: (val: string) => void
  isEnabledZero?: boolean
}
export const PaxSelect = (props: React.PropsWithChildren<Props>) => {
  const id = uuid()
  const menuHeight = 449
  const menuWidth = 159
  const defaultOptions = Array.from(new Array(6)).map((v, i) => `${i + (props.isEnabledZero ? 0 : 1)}`)
  const isAnyValue = props.value && !defaultOptions.includes(props.value)

  const { t } = useTranslation()
  const [menuTopPosition, setMenuTopPosition] = React.useState<number>()
  const [tempAnyInput, setTempAnyInput] = React.useState<string>(isAnyValue ? props.value! : '')

  const menu = (
    <Menu
      onClick={e => {
        if (e.key !== 'any') {
          props.onClick(e.key)
        }
      }}
      selectedKeys={isAnyValue ? ['any'] : [props.value || '']}
    >
      {defaultOptions.map(opt => (
        <Menu.Item key={opt} style={{ fontSize: 21, lineHeight: '51px', paddingLeft: 35 }}>
          <div>{opt}</div>
        </Menu.Item>
      ))}
      <Menu.Item key={'any'} disabled>
        <InputField
          type="tel"
          pattern="^[0-9]+$"
          value={tempAnyInput}
          onClick={e => e.stopPropagation()}
          onChange={e => {
            if (!Number.isNaN(Number(e.target.value))) {
              setTempAnyInput(e.target.value)
            }
          }}
          marginBottom={0}
          customInputStyle={{
            color: 'rgba(0, 0, 0, 0.65)',
            fontSize: 21,
            paddingLeft: 35,
            height: 51,
            borderRadius: 40,
          }}
          placeholder={`${Number(defaultOptions.slice(-1)[0]) + 1}+`}
        />
      </Menu.Item>
    </Menu>
  )

  const customStyle = React.useMemo(() => {
    if (!menuTopPosition) {
      return css()
    }
    return css({
      '.pax-select-options': { top: `${menuTopPosition}px !important`, maxWidth: menuWidth, minWidth: `${menuWidth}px !important` },
    })
  }, [menuTopPosition])

  return (
    <div id={`wrapper-${id}`} css={customStyle}>
      <Dropdown
        overlayClassName={'pax-select-options'}
        onVisibleChange={visible => {
          if (!visible && tempAnyInput) {
            props.onClick(tempAnyInput)
            return
          }

          const selectBoxDom = document.getElementById(`wrapper-${id}`)
          if (!selectBoxDom) {
            return
          }
          const margin = 4
          const isBelowHalfScreen = window.innerHeight / 2 < selectBoxDom.getBoundingClientRect().top
          if (isBelowHalfScreen) {
            setMenuTopPosition(selectBoxDom.offsetTop - menuHeight - margin)
          } else {
            setMenuTopPosition(selectBoxDom.offsetTop + selectBoxDom.offsetHeight + margin)
          }
        }}
        overlay={menu}
        trigger={['click']}
        getPopupContainer={() => document.getElementById(`wrapper-${id}`)!}
      >
        <div css={paxSelectStyle}>
          <div css={paxSelectBoxStyle}>{props.value}</div>
          <span css={paxSelectUnitStyle}>{t('Person')}</span>
        </div>
      </Dropdown>
    </div>
  )
}

const paxSelectStyle = css({ display: 'flex', alignItems: 'center', gap: 16 })

const paxSelectBoxStyle = css(
  {
    width: 159,
    height: 61,
    border: '1px solid rgb(204, 204, 204)',
    color: 'rgb(39, 39, 39)',
    borderRadius: 40,
    fontSize: 21,
    padding: '14px 35px',
    appearance: 'none',
    backgroundImage: `url(${require('@/static/images/arrow_down_yellow.svg')})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '108px center',
    backgroundSize: 14,
    backgroundColor: 'rgb(255, 255, 255)',
    display: 'block',
    lineHeight: '31px',
  },
  createSelfCheckinBaseStyle({
    height: 59,
    fontSize: 22,
    fontWeight: 500,
    letterSpacing: '1.1px',
    lineHeight: '29px',
  }),
  createSelfCheckinResponsiveStyle({
    landscape13: { height: 64, fontSize: 26, fontWeight: 500, letterSpacing: '1.3px', lineHeight: '34px' },
  }),
)

const paxSelectUnitStyle = css(
  { fontSize: 22, fontWeight: 500, letterSpacing: '1.1px', color: '#272727' },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: FrontTabletResponsiveToken.formInputFontSize.landscape13, letterSpacing: '1.3px' },
  }),
)
